// i18n
import { changeLanguage, translateInComponent } from 'infras/i18n';

import translations from './i18n.json';
import { SyntheticEvent, useCallback } from 'react';
import Link from 'presentations/views/components/atoms/Link';
import Logo from 'presentations/views/components/atoms/Logo';

import { fontSize, mediaMax, spacing } from 'presentations/views/styles';
import styled from '@emotion/styled';
import {
  eventTypeCancelPolicyPath,
  eventTypeTermPath,
  eventTypeTokushohoPath,
  homePath,
  webPath,
} from 'presentations/routes/path';
import { gray01, primary } from 'presentations/views/styles/color';
import LanguageSelect from 'presentations/views/components/molecules/LanguageSelect';
import { useRouter } from 'next/router';
import { CancelPolicyItem } from 'presentations/api/schema/cancel_policy';
import { TermItem } from 'presentations/api/schema/term';
import { Amplitude } from 'presentations/views/helpers/analytics/amplitude';

interface Props {
  eventTypeSlug: string;
  teamSlug: string;
  onClickInquiry: any;
  isIncludeServiceJP: boolean;
  isInputTokushoho: boolean;
  cancelPolicy: CancelPolicyItem | null;
  term: TermItem | null;
  isShowPromotion: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  const router = useRouter();
  const onChangeLocale = useCallback(
    (e: SyntheticEvent<HTMLInputElement>) => {
      router.push(router.asPath, undefined, {
        locale: e.currentTarget.value,
      });
    },
    [router],
  );

  const onClickLogo = useCallback(() => {
    Amplitude.signUpLeadClick({
      pageType: 'eventType',
      to: 'top',
      position: 'footer',
    });
  }, []);

  const isJpService = !!props.isInputTokushoho && !!props.isIncludeServiceJP;

  return (
    <Container>
      <LinkList>
        {props.isShowPromotion && (
          <LinkListLink onClick={props.onClickInquiry}>
            <LinkListLinkTitle>{t('Inquiry Link')}</LinkListLinkTitle>
          </LinkListLink>
        )}
        {isJpService && (
          <LinkListLink
            href={eventTypeTokushohoPath(props.teamSlug!, props.eventTypeSlug)}
            target="_blank"
          >
            <LinkListLinkTitle>{t('Tokushoho Link')}</LinkListLinkTitle>
          </LinkListLink>
        )}
        {props.term && (
          <LinkListLink
            href={eventTypeTermPath(props.teamSlug!, props.eventTypeSlug)}
            target="_blank"
          >
            <LinkListLinkTitle>{t('Term Link')}</LinkListLinkTitle>
          </LinkListLink>
        )}
        {props.cancelPolicy && (
          <LinkListLink
            href={eventTypeCancelPolicyPath(
              props.teamSlug!,
              props.eventTypeSlug,
            )}
            target="_blank"
          >
            <LinkListLinkTitle>{t('CancelPolicy Link')}</LinkListLinkTitle>
          </LinkListLink>
        )}
        <LanguageSelect onChangeLocale={onChangeLocale} />
      </LinkList>
      {props.isShowPromotion && (
        <LogoContainer>
          <Link href={homePath()} onClick={onClickLogo}>
            <Logo variant="gray" />
          </Link>
        </LogoContainer>
      )}
    </Container>
  );
}
const Container = styled.div`
  ${mediaMax.tablet} {
    margin-bottom: ${spacing(24)};
    padding: 0 ${spacing(16)};
  }
  ${mediaMax.smartphone} {
    display: block;
    text-align: center;
  }
`;
const LinkList = styled.div`
  display: flex;
  justify-content: center;
  ${mediaMax.smartphone} {
    margin-bottom: ${spacing(16)};
    flex-wrap: wrap;
  }
`;
const LinkListLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${gray01};
  margin-right: ${spacing(16)};
  &:hover {
    color: ${primary};
  }
  ${mediaMax.smartphone} {
    padding: ${spacing(8)} 0;
  }
`;
const LinkListLinkTitle = styled.span`
  font-size: ${fontSize(12)};
`;

const LogoContainer = styled.div`
  margin-top: ${spacing(24)};
  text-align: center;
`;
